<template>
  <div class="swc-content">
    <div class="type-title">
      <div class="billing-left"></div>
      <div class="billing-right">
        <div class="details" @click="shuaxin">
          刷新
          <!--          <img src="../../assets/sx.png" class="shuaxin" @click="shuaxin">-->
        </div>
        <div class="details" @click="toDingJin">
          <span class="iconfont"></span>预定管理
        </div>
        <div class="details" @click="toAddMember">
          <span class="iconfont"></span>创建客户
        </div>
        <div class="details" @click="toHaiKuan">
          <span class="iconfont icon-shoukuan"></span>还款
        </div>
        <div class="details-right" style="cursor: pointer" @click="toBilling">会员开单</div>
        <div class="details-right" style="cursor: pointer" @click="skBilling">散客开单</div>
      </div>
    </div>

    <div class="so-details">
      <div :class="item.orderStatus==3?'so-table1':'so-table2'" v-if="billingList.length>0"
           v-for="(item, index) in billingList">
        <div class="sot-header">
          <div class="sot-id1">
            <span>服务号</span>
            <span :class="item.orderStatus==3?'gh1':'gh2'" @click="toFwh(item)">更换服务号</span>
          </div>
          <span class="sot-id">{{item.serviceName}}</span>
        </div>
        <div class="sot-username">
          <p v-if="item.memberName">{{ item.memberName }}</p>
          <p v-if="!item.memberName">散客</p>
        </div>
        <div class="sot-time">
          <span class="sotime">开始时间: {{item.createTime}}</span>
          <span class="sotime">结束时间: {{item.orderStatus==3?'无':item.endTime}}</span>
        </div>
        <div class="neirong">
          <div class="xfxx">
            <span>消费数量</span>
            <span>{{item.itemNum}}</span>
          </div>
          <div class="xfxx">
            <span>消费金额</span>
            <span style="color: #ee0a24">¥ {{item.totalPrice}}</span>
          </div>
        </div>
        <div class="btn-item" style="padding-top: 8px">
          <div class="xqdan">
            <div style="display: flex">
              <i class="el-icon-delete tb"/>
              <span @click="toDel(item)" style="margin-right: 20px">删除订单</span>
            </div>
            <div style="display: flex">
              <i class="el-icon-menu tb"/>
              <span @click="toLook(item)">订单详情</span>
            </div>
          </div>
          <div :class="item.orderStatus==3?'qdan1':'qdan2'" @click="takeOrder(item)">
            <i class="el-icon-s-unfold tb1"/>
            <span style="margin-left: 5px">取单</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="lookVisible" width="500px">
      <div style="text-align: center;">
        <el-table
          :data="items"
          height="350"
          border
          show-summary
          style="width: 100%">
          <el-table-column prop="itemName" label="项目" :show-overflow-tooltip="true" width="168"/>
          <el-table-column prop="price" label="价格"/>
          <el-table-column prop="num" label="数量"/>
          <el-table-column prop="address" label="类型">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.add&&scope.row.add>0">加 {{scope.row.add}}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 删除单子 -->
    <el-dialog title="删除订单" :visible.sync="delVisible" width="30%">
      <div style="text-align: center;">
        是否删除订单?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="delVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="delMethod">确 定</el-button>
      </span>
    </el-dialog>

    <TabMemberList
      v-if="mbVisible"
      :mbVisible="mbVisible"
      @setMember="setMember"
      @setMemberCard="setMemberCard"
      @closeML="closeML"
    />

    <TabSaveMember
      v-if="smVisible"
      :smVisible="smVisible"
      @setMember="setMember"
      @closeSM="closeSM"
    />
    <TabFwh
      v-if="fwhVisible"
      :fwhVisible="fwhVisible"
      :orderId="orderId"
      @successFwh="successFwh"
      @closeFwh="closeFwh"
    />
  </div>
</template>

<script>
  import {getToken} from "../../utils/auth";
  import TabMemberList from "../common/member/memberList";
  import TabSaveMember from "../common/member/saveMember";
  import TabFwh from "../common/service/fwh";
  export default {
    name: "dashboard",
    components: {
      TabMemberList,
      TabSaveMember,
      TabFwh,
    },
    data() {
      return {
        checked: true,
        input2: "",

        radio: "",

        item: {},
        billingList: [],
        memberArrearsList: [],

        remarks: "",
        delVisible: false,

        items: [],
        lookVisible: false,

        assetsVisible: false,
        mbVisible: false,
        times: [],

        smVisible: false,
        fwhVisible: false,
        orderId:'',
      };
    },
    async created() {
      this.getBillingList();
    },
    methods: {
      toFwh(item) {
        this.orderId=item.id
        this.fwhVisible = true
      },
      successFwh() {
        this.getBillingList()
        this.fwhVisible = false;
      },
      closeFwh() {
        this.fwhVisible = false;
      },
      shuaxin() {
        this.getBillingList();
      },
      //创建客户
      toAddMember() {
        this.smVisible = true;
      },
      closeSM() {
        this.smVisible = false;
      },
      //会员开单
      toBilling() {
        this.mbVisible = true;
      },

      //散客开单
      skBilling() {
        this.$router.push(`/cashiers/billing`);
      },

      //定金管理
      toDingJin() {
        this.$router.push(`/deposits/deposit`);
      },

      toHaiKuan() {
        this.$router.push('/cashiers/arrears');
      },


      //选择会员信息
      setMember(item) {
        this.closeML();
        this.$router.push(`/cashiers/billing?memberId=` + item.id);
        this.closeSM();
      },

      //选择会员卡信息
      setMemberCard(mb, mc) {
        this.$router.push(`/cashiers/billing?memberId=` + mb.id + '&mcId=' + mc.id);
        this.closeML();
      },

      closeML() {
        this.mbVisible = false;
      },

      toLook(item) {
        this.items = []
        if (item.itemStr && item.itemStr.length > 0) {
          this.items = this.items.concat(item.itemStr)
        }
        if (item.skuStr && item.skuStr.length > 0) {
          this.items = this.items.concat(item.skuStr)
        }
        if (item.specStr && item.specStr.length > 0) {
          this.items = this.items.concat(item.specStr)
        }
        this.items.forEach(item => {
          item.num = 1
        })
        this.lookVisible = true;
      },

      toDel(item) {
        this.item = item;
        this.delVisible = true;
      },

      async delMethod() {
        let data = {
          id: this.item.id,
        };
        let res = await this.$post("/sw/deleteBilling", data);
        if (res.code == 200) {
          this.getBillingList();
          this.delVisible = false;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      },

      async getBillingList() {
        let data = {
          token: getToken(),
        };
        let res = await this.$get("/sw/getBillingList", data);
        if (res.code == 200) {
          this.billingList = res.orders;
          this.billingList.forEach(item => {
            item.itemStr = JSON.parse(item.itemStr)
            item.skuStr = JSON.parse(item.skuStr)
            item.specStr = JSON.parse(item.specStr)
            let i = 0;
            if (item.itemStr && item.itemStr.length) {
              i = i + item.itemStr.length
            }
            if (item.skuStr && item.skuStr.length) {
              i = i + item.skuStr.length
            }
            if (item.specStr && item.specStr.length) {
              i = i + item.specStr.length
            }
            item.itemNum = i
          })
        }
      },


      takeOrder(item) {
        this.$router.push('/cashiers/reorder?orderId=' + item.id);
      },
    },

  };
</script>


<style lang="scss" scoped>

  .swc-content {
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: scroll;
  }

  .type-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    line-height: 60px;
    background-color: #f5f5f5;
  }

  .billing-left {
    width: 50%;
  }

  .billing-right {
    padding-right: 5px;
    display: flex;
    text-align: center;

    .details {
      width: 100px;
      height: 60px;
      line-height: 60px;
      background-color: #fff;
      border: #d2d2d2 solid 1px;
      cursor: pointer;

      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }

    .details:hover {
      background-color: #f5f5f5;
    }

    .details-right {
      width: 130px;
      height: 60px;
      background-color: #555555;
      color: #fff;
    }
  }

  .so-content {
    height: 40px;
    line-height: 40px;
  }

  .so-details {
    width: 100%;
  }

  .so-table1 {
    float: left;
    margin: 10px;
    width: 238px;
    height: 325px;
    border: 1px solid #dccdb6;
    padding-right: 8px;
    padding-left: 8px;
    border-left: 5px solid #E6C696;
  }

  .so-table2 {
    float: left;
    margin: 10px;
    width: 238px;
    height: 325px;
    border: 1px solid #dccdb6;
    padding-right: 8px;
    padding-left: 8px;
    border-left: 5px solid #718CC7;
  }

  .sot-id2 {
    margin-left: 5px;
    display: inline-block;
    font-size: 10px;
    font-weight: bold;
    height: 20px;
    line-height: 20px;
    margin-top: 3px;
    cursor: pointer;
  }

  .sot-id1 {
    display: inline-block;
    font-size: 17px;
    font-weight: bold;
    height: 30px;
    line-height: 25px;
    margin-top: 3px;
  }

  .sot-id {
    display: inline-block;
    font-size: 17px;
    color: red;
    font-weight: bold;
    height: 30px;
    line-height: 25px;
    margin-top: 3px;
  }

  .yuan {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #f0f0f0;
    border: 1px #d1d1d1 solid;
    display: inline-block;
  }

  .sot-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 30px;
    margin-top: 10px;
  }

  .sot-username p {
    font-size: 13px;
    color: #222222;
    font-weight: bold;
    height: 20px;
    line-height: 20px;
  }

  .sot-time {
    display: flex;
    flex-direction: column;
    color: #515151;
    font-size: 10px;
    margin-top: 3px;
  }

  .sotime {
    display: inline-block;
    height: 20px;
    line-height: 20px;
  }

  .table-name p {
    color: #505050;
    height: 25px;
    font-size: 13px;
  }

  .btn-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 60px;
  }

  .xqdan {
    width: 85%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .qdan1 {
    width: 85%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #E6C696;
    color: #fff;
    height: 25px;
    line-height: 25px;
    margin-top: 3px;
    cursor: pointer;
  }

  .qdan2 {
    width: 85%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #718CC7;
    color: #fff;
    height: 25px;
    line-height: 25px;
    margin-top: 3px;
    cursor: pointer;
  }

  .xqdan span {
    text-align: center;
    height: 22px;
    line-height: 22px;
    margin: 5px;
    cursor: pointer;
  }

  .shuaxin {
    width: 35px;
    height: 35px;
    margin-left: 60px;
  }

  .neirong {
    padding: 25px 15px;
    border-top: #e5e5e5 solid 1px;
    margin-top: 8px;
  }

  .xfxx {
    height: 25px;
    line-height: 25px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .xfxx span {
    width: 50%;
  }

  .tb {
    font-size: 20px;
    line-height: 32px;
    color: #BFBFBF;
  }

  .tb1 {
    font-size: 18px;
    line-height: 25px;
  }

  .gh1 {
    margin-left: 5px;
    background-color: #E6C696;
    color: #fff;
    height: 20px;
    line-height: 20px;
    margin-top: 3px;
    cursor: pointer;
    font-size: 10px;
    padding: 1px 3px;
  }

  .gh2 {
    margin-left: 5px;
    background-color: #718CC7;
    color: #fff;
    height: 20px;
    line-height: 20px;
    margin-top: 3px;
    cursor: pointer;
    font-size: 10px;
    padding: 1px 3px;
  }
</style>
